
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';



export interface TATReportParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface TATReport {
     WorkOrderDetId : any,
     ServicesubcategoryId: any,
     Status:string,
     DoneBy:number,
     DoneDate:Date,
     TenantId:any,
     BranchId:any

    parameters?: TATReportParameter[];
    links?: any;
    LabWorkOrderReg?:any;
    entryFrom?:string;
    AppointmentId?:any;
    queueFlag?:boolean;
}

export abstract class TATReportData {     

    abstract list(url: string): Observable<TATReport[]>; 
    abstract create(url: string, data: TATReport): Observable<TATReport[]>;
    abstract update(url: string, data: TATReport): Observable<TATReport>;
    abstract delete(url: string): Observable<any>; 
}
